import { useEffect, useState } from 'react';
import Modal from '@shape-construction/arch-ui/src/Modal';
import { environment } from 'app/config/environment';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router';

const CookieDeclaration = () => {
  const { t } = useTranslation();
  const [openModal, setOpenModal] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();

  const closeModal = () => {
    setOpenModal(false);
    if (location.key !== 'default') {
      navigate(-1);
    } else {
      navigate('/my-profile');
    }
  };

  // The modal content is portaled and only mounts after the first render,
  // so track the container with state instead of a ref to inject the script
  // once the element exists.
  const [cookieDeclarationContainer, setCookieDeclarationContainer] = useState<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!cookieDeclarationContainer) return;

    const script = document.createElement('script');

    script.id = 'CookieDeclaration';
    script.src = `https://consent.cookiebot.com/${environment.COOKIEBOT_DOMAIN_GROUP_ID}/cd.js`;
    script.type = 'text/javascript';
    script.async = true;

    cookieDeclarationContainer.appendChild(script);

    return () => {
      script.remove();
    };
  }, [cookieDeclarationContainer]);

  return (
    <Modal.Root open={openModal} onClose={closeModal} maxWidth="3xl">
      <Modal.Header onClose={closeModal}>
        <Modal.Title>{t('myAccount.privacy.cookieDeclaration')}</Modal.Title>
      </Modal.Header>
      <Modal.Content className="py-6">
        <div ref={setCookieDeclarationContainer} />
      </Modal.Content>
    </Modal.Root>
  );
};

export default CookieDeclaration;
